import * as actionTypes from '../constants/actionType';
import initialState from './initialState';

export default function mLatestNewsReducer(state = initialState.mLatestNews, action) {
  switch (action.type) {
    case actionTypes.MLATESTNEWS_LOAD_START:
      return {
        ...state,
        isLoading: true
      };

    case actionTypes.MLATESTNEWS_LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case actionTypes.MLATESTNEWS_LOAD_SUCCESS: {
      return {
        ...state,
        ...action.data,
        isLoading: false,
        error: undefined
      };
    }

    default:
      return state;
  }
}
